import { Carousel } from "antd"
import { useRef } from "react"
import styles from "../index.module.less"
import { classModuleGenerator } from "@/utils"
const classnames = classModuleGenerator(styles)

function Teacher({ teachers = [] }) {
  const carouselRef = useRef()

  return (
    <section className={styles["teacher-container"]}>
      <div className={classnames("teacher-container-bg")}>
        <h3 className="section__title">学大全日制教师团队</h3>
        <div className="section__inner">
          {teachers.length > 1 && (
            <>
              <div
                className={classnames("slick-prev")}
                onClick={() => {
                  carouselRef.current.prev()
                }}
              >
                <img
                  src={require("@/assets/images/icon_arrow_left.png")}
                  alt=""
                />
              </div>
              <div
                className={classnames("slick-next")}
                onClick={() => {
                  carouselRef.current.next()
                }}
              >
                <img
                  src={require("@/assets/images/icon_arrow_right.png")}
                  alt=""
                />
              </div>
            </>
          )}

          <Carousel autoplay={true} dots={false} ref={carouselRef}>
            {teachers.map((m) => {
              return (
                <div key={m._id}>
                  <div className={classnames("teacher-content")}>
                    <div className={classnames("techer-content_bd", "resume")}>
                      <div className={classnames("teacher-info")}>
                        <h4>{m.name}</h4>
                        <p>教师资格证编号：{m.certificate}</p>
                      </div>
                      <p>{m.intro}</p>
                      <button
                        className="home-btn"
                        onClick={() => {
                          if (m.jumpUrl) window.open(m.jumpUrl)
                          else window.openJesongChatByGroup(121, 52601)
                          return false
                        }}
                      >
                        了解详情
                      </button>
                    </div>
                    <div className={classnames("techer-content_ft")}>
                      <img src={m.photoUrl} alt="" />
                    </div>
                  </div>
                </div>
              )
            })}
          </Carousel>
        </div>
      </div>
    </section>
  )
}

export default Teacher
